export const getBasedUrl = (url: string, baseUrl: string) => `${baseUrl.replace(/\/+$/, '')}${url}`;
